import React from 'react';
import './location.css';

const KakaoMapEmbed = () => {
  return (
    <div className="location-section">
      <div className="location-container">
        {/* 헤더 섹션 */}
        <div className="location-header">
          <h2 className="location-title">오시는길</h2>
          <p className="location-subtitle">
            가까운 물류를 찾아주셔서 감사합니다.<br />
            아래 주소로 방문해 주시거나 연락 주시기 바랍니다.
          </p>
        </div>

        {/* 카카오맵 - 위쪽에 배치 */}
        <div className="map-container">
          <div
            style={{
              font: "normal normal 400 12px/normal dotum, sans-serif",
              width: "100%",
              maxWidth: "800px",
              height: "400px",
              color: "#333",
              position: "relative"
            }}
          >
            <div style={{ height: "400px" }}>
              <a
                href="https://map.kakao.com/?urlX=941743.0000002088&urlY=462329.0000000072&name=%EB%B6%80%EC%82%B0%20%EA%B0%95%EC%84%9C%EA%B5%AC%20%EB%A7%A5%EB%8F%84%EA%B8%B8509%EB%B2%88%EA%B8%B8%2030&map_type=TYPE_MAP&from=roughmap"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="map"
                  src="http://t1.daumcdn.net/roughmap/imgmap/1562ab5a8ea0eac553e9fdb790fdb65a2db03acfa9286407bfb6fe2b103742f0"
                  width="100%"
                  height="398px"
                  style={{ border: "1px solid #ccc", maxWidth: "100%" }}
                  alt="카카오맵 미리보기"
                />
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default KakaoMapEmbed;
